"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceAnchor = exports.ChoiceLink = exports.ChoiceButton = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Badge_1 = require("../../atoms/Badge/Badge");
const CHOICE_CONTAINER_BASE_STYLE = 'block group relative w-full rounded-lg bg-slate-1 focus:outline-none focus:ring focus:ring-blue-4/40 text-blue-5 hover:text-purple-5 disabled:hover:text-blue-5 disabled:opacity-60';
const CHOICE_TEXT_STYLE = 'px-6 py-4 text-left text-2xl font-bold leading-7';
const BADGE_STYLE = 'absolute -top-0 left-8 -translate-y-1/2';
const ChoiceButton = ({ onClick, type = 'button', disabled, children, badge, className, asLink, }) => {
    return (react_1.default.createElement("button", { className: `${CHOICE_CONTAINER_BASE_STYLE} ${className}`, onClick: onClick, disabled: disabled, type: type, role: asLink ? 'link' : undefined },
        badge && react_1.default.createElement(Badge_1.Badge, { className: BADGE_STYLE }, badge),
        react_1.default.createElement("div", { className: CHOICE_TEXT_STYLE }, children)));
};
exports.ChoiceButton = ChoiceButton;
const ChoiceLink = ({ to, children, className, badge }) => {
    return (react_1.default.createElement(react_router_dom_1.Link, { to: to, className: `${CHOICE_CONTAINER_BASE_STYLE} ${className}` },
        badge && react_1.default.createElement(Badge_1.Badge, { className: BADGE_STYLE }, badge),
        react_1.default.createElement("div", { className: CHOICE_TEXT_STYLE }, children)));
};
exports.ChoiceLink = ChoiceLink;
const ChoiceAnchor = ({ href, target, children, className, badge }) => {
    return (react_1.default.createElement("a", { href: href, target: target, className: `${CHOICE_CONTAINER_BASE_STYLE} ${className}` },
        badge && react_1.default.createElement(Badge_1.Badge, { className: BADGE_STYLE }, badge),
        react_1.default.createElement("div", { className: CHOICE_TEXT_STYLE }, children)));
};
exports.ChoiceAnchor = ChoiceAnchor;
